export default __webpack_public_path__ + "38ea7c80eaa4b0a6779286174ac73134.png";